export const SpaceInfluenceType = {
  HighlightRow: 'HighlightRow',
} as const;

export type SpaceInfluenceType = (typeof SpaceInfluenceType)[keyof typeof SpaceInfluenceType];

export interface HighlightRowSpaceInfluence {
  type: typeof SpaceInfluenceType.HighlightRow;
  rowId: string;
}

export type SpaceInfluence = HighlightRowSpaceInfluence;
